import styles from "./Designer.module.css";

const DesignerHeaderSection = ({
    variants = [],
    variantError = null,
    onClose,
    isPageVariant = false,
}) => {
    return (
        <>
            <div className={styles.header}>
                <h2 className={styles.headerTitle}>Diseñador de Prenda</h2>
                <div className={styles.headerActions}>
                    {onClose ? (
                        <button
                            className={styles.close}
                            onClick={onClose}
                            aria-label={isPageVariant ? "Volver" : "Cerrar"}
                            title={isPageVariant ? "Volver" : "Cerrar"}
                        >
                            {isPageVariant ? (
                                <span className={styles.closeIcon} aria-hidden="true">
                                    <svg viewBox="0 0 24 24" focusable="false">
                                        <path d="M11 5L3 12L11 19V14H21V10H11V5Z" fill="currentColor" />
                                    </svg>
                                </span>
                            ) : "Cerrar"}
                        </button>
                    ) : null}
                </div>
            </div>
            {variantError ? <div className={styles.infoHint}>{variantError}</div> : null}
        </>
    );
};

export default DesignerHeaderSection;
